import request from "./request";

const quickbooks = {
   async connect() {
      const res = await request.get('/api/finance/quickbooks/config-link');
		window.location.href = res.data.url;
   },

}

export default quickbooks;